/** Location identifiers remain strings so leading zeros survive storage and URLs. */
export function isStoreCode(value: string): boolean {
  return /^(?:CFA[0-9]{5}|[0-9]{8})$/.test(value);
}

/** Five-digit entry preserves existing customers' familiar store-number shortcut. */
export function parseStoreEntry(value: string): string | null {
  const normalized = value.trim().toUpperCase();
  if (/^[0-9]{5}$/.test(normalized)) return `CFA${normalized}`;
  return isStoreCode(normalized) ? normalized : null;
}

export function locationDisplayId(storeCode: string): string {
  return /^CFA[0-9]{5}$/.test(storeCode) ? storeCode.slice(3) : storeCode;
}
